export default "__VITE_ASSET__BHZNwTpq__"